import React from 'react';
import { Link } from 'react-router-dom';

const DISCORD_URL = 'https://discord.gg/Frbjdmtbrt';

function DiscordIcon({ className = 'w-4 h-4' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M20.317 4.369a19.79 19.79 0 00-4.885-1.515.074.074 0 00-.079.037c-.21.375-.444.864-.608 1.249a18.27 18.27 0 00-5.487 0 12.6 12.6 0 00-.617-1.25.077.077 0 00-.079-.036A19.736 19.736 0 003.677 4.37a.07.07 0 00-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 00.031.057 19.9 19.9 0 005.993 3.03.078.078 0 00.084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 00-.041-.106 13.1 13.1 0 01-1.872-.892.077.077 0 01-.008-.128c.126-.094.252-.192.372-.291a.074.074 0 01.077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 01.078.009c.12.099.246.198.373.292a.077.077 0 01-.006.127c-.598.35-1.22.645-1.873.891a.077.077 0 00-.041.107c.36.698.772 1.363 1.225 1.993a.076.076 0 00.084.028 19.839 19.839 0 006.002-3.03.077.077 0 00.032-.056c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 00-.031-.028zM8.02 15.331c-1.182 0-2.157-1.085-2.157-2.419 0-1.333.956-2.418 2.157-2.418 1.21 0 2.176 1.095 2.157 2.418 0 1.334-.956 2.419-2.157 2.419zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.418 2.157-2.418 1.21 0 2.176 1.095 2.157 2.418 0 1.334-.946 2.419-2.157 2.419z" />
    </svg>
  );
}

function FooterLink({ to, href, children }) {
  const cls = 'text-sm text-gray-500 hover:text-gray-200 transition-colors duration-150';
  if (href) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" className={cls}>
        {children}
      </a>
    );
  }
  return <Link to={to} className={cls}>{children}</Link>;
}

export default function Footer() {
  return (
    <footer className="relative mt-auto">
      <div className="hairline" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4">

          {/* Márka */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-flex items-center gap-3 mb-4">
              <img src="/newlogo.png" alt="" className="w-8 h-8 object-contain" />
              <span className="font-display font-bold text-white tracking-tight">
                Mortis<span className="text-brand-300">Engine</span>
              </span>
            </Link>
            <p className="text-sm text-gray-500 leading-relaxed max-w-sm">
              The most advanced Drakensang Online automation suite — auto farming,
              auto loot, auto sell and a full waypoint autopilot, always kept up to date.
            </p>
            <a
              href={DISCORD_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-5 inline-flex items-center gap-2 px-3.5 py-2 rounded-lg
                         bg-white/[0.04] border border-white/[0.08] text-sm text-gray-300
                         hover:bg-white/[0.07] hover:text-white hover:border-white/[0.14]
                         transition-all duration-200 ease-smooth"
            >
              <DiscordIcon className="w-4 h-4 text-[#8f7cf5]" />
              Join our Discord
            </a>
          </div>

          {/* Termék */}
          <div>
            <h3 className="text-xs font-semibold uppercase tracking-wider text-gray-400 mb-4">
              Product
            </h3>
            <ul className="space-y-2.5">
              <li><FooterLink to="/">Home</FooterLink></li>
              <li><FooterLink to="/docs">Documentation</FooterLink></li>
              <li><FooterLink to="/panel">Dashboard</FooterLink></li>
            </ul>
          </div>

          {/* Jogi */}
          <div>
            <h3 className="text-xs font-semibold uppercase tracking-wider text-gray-400 mb-4">
              Legal
            </h3>
            <ul className="space-y-2.5">
              <li><FooterLink to="/terms">Terms of Service</FooterLink></li>
              <li><FooterLink to="/rules">Rules &amp; Acceptable Use</FooterLink></li>
              <li><FooterLink to="/privacy">Privacy Policy</FooterLink></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/[0.06] flex flex-col sm:flex-row
                        items-center justify-between gap-3">
          <p className="text-xs text-gray-600">
            © {new Date().getFullYear()} MortisEngine. All rights reserved.
          </p>
          <p className="text-xs text-gray-600">
            Not affiliated with or endorsed by the publishers of Drakensang Online.
          </p>
        </div>
      </div>
    </footer>
  );
}
